import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgStar(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 2.75C16.4877 2.75 16.9308 3.03361 17.1351 3.47644L20.5098 10.7928L28.5109 11.7415C28.9952 11.7989 29.4019 12.1327 29.5526 12.5965C29.7033 13.0603 29.5705 13.5694 29.2124 13.9005L23.297 19.3709L24.8673 27.2736C24.9623 27.7519 24.7705 28.2418 24.3759 28.5285C23.9814 28.8151 23.4562 28.8462 23.0307 28.608L16 24.6725L8.96935 28.608C8.54381 28.8462 8.0186 28.8151 7.62407 28.5285C7.22954 28.2418 7.03773 27.7519 7.13277 27.2736L8.70302 19.3709L2.78758 13.9005C2.42955 13.5694 2.29675 13.0603 2.44745 12.5965C2.59815 12.1327 3.00482 11.7989 3.4891 11.7415L11.4902 10.7928L14.8649 3.47644C15.0692 3.03361 15.5123 2.75 16 2.75ZM16 6.98439L13.4673 12.4753C13.2852 12.87 12.9111 13.1419 12.4794 13.193L6.4746 13.905L10.9141 18.0105C11.2333 18.3057 11.3762 18.7455 11.2914 19.1719L10.113 25.1028L15.3895 22.1493C15.7688 21.9369 16.2312 21.9369 16.6106 22.1493L21.887 25.1028L20.7086 19.1719C20.6238 18.7455 20.7667 18.3057 21.0859 18.0105L25.5254 13.905L19.5206 13.193C19.0889 13.1419 18.7148 12.87 18.5327 12.4753L16 6.98439Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgStar);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
